import { render, staticRenderFns } from "./DT_ReleaseModal.vue?vue&type=template&id=74ee930f&"
import script from "./DT_ReleaseModal.vue?vue&type=script&lang=js&"
export * from "./DT_ReleaseModal.vue?vue&type=script&lang=js&"
import style0 from "./DT_ReleaseModal.vue?vue&type=style&index=0&id=74ee930f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports